import { render, staticRenderFns } from "./flowList2.vue?vue&type=template&id=6235cad5&scoped=true&"
import script from "./flowList2.vue?vue&type=script&lang=js&"
export * from "./flowList2.vue?vue&type=script&lang=js&"
import style0 from "./flowList2.vue?vue&type=style&index=0&id=6235cad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235cad5",
  null
  
)

export default component.exports